import {AuswahlProdukt} from "@k/js/product";
import {DIALOGS} from "@k/global/dialogDefinitions";
import {Produktwechsel} from "@km/components/productChange/Produktwechsel";
import {noop} from "@k/global/globalUtils";
import { displayTwoButtonDialog } from "@km/components/popups/ConfirmOrConfirmCancelDialog";


export function showChangeToNewProductDialog(store, i18n, newProduct: string, newAuswahlProdukt: AuswahlProdukt) {

    const dialog = DIALOGS.deprecatedProduct;
    displayTwoButtonDialog(
        i18n.t(dialog.title.id),
        i18n.t(dialog.message.id).replace("__replacedBy__", "<strong\"" + newProduct + "\"</stong>"),
        i18n.t("km_changeToProduct").replace("__target__", newProduct),
        i18n.t(dialog.buttons[0].text.id),
        false
    )
        .then(() => Produktwechsel.productChosen(newAuswahlProdukt.Produkt))
        .catch(noop);
}